import { render, staticRenderFns } from "./title.vue?vue&type=template&id=927968c8&scoped=true"
import script from "./title.vue?vue&type=script&lang=ts"
export * from "./title.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927968c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\WebDev\\Source\\PeppermillReno.com\\[DEV]\\[WEB] PeppermillReno.com DEV\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('927968c8')) {
      api.createRecord('927968c8', component.options)
    } else {
      api.reload('927968c8', component.options)
    }
    module.hot.accept("./title.vue?vue&type=template&id=927968c8&scoped=true", function () {
      api.rerender('927968c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "library/js/components/view-room-details/title.vue"
export default component.exports